import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import type { CrmUserJgsData } from "@/services/adminCrm";

interface Props {
  jgsData: CrmUserJgsData | null;
  linked: boolean;
}

function val(v: string | number | null | undefined): string {
  if (v === null || v === undefined || v === "") return "\u2014";
  return String(v);
}

export function UserJGSSection({ jgsData, linked }: Props) {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <CardTitle className="text-base">JGS Data</CardTitle>
          <Badge
            variant="outline"
            className={
              linked
                ? "bg-green-100 text-green-800 border-green-200 text-xs"
                : "bg-gray-100 text-gray-600 border-gray-200 text-xs"
            }
          >
            {linked ? "Linked" : "Not Linked"}
          </Badge>
        </div>
      </CardHeader>
      <CardContent>
        {!linked || !jgsData ? (
          <p className="text-sm text-muted-foreground">Not linked to a JGS profile.</p>
        ) : (
          <div className="space-y-2 text-sm">
            {[
              { label: "Rank", value: val(jgsData.rank) },
              { label: "Scoring Differential", value: val(jgsData.scoringDifferential) },
              { label: "State Rank", value: val(jgsData.stateRank) },
              { label: "State", value: val(jgsData.state) },
              { label: "Events", value: val(jgsData.events) },
            ].map(f => (
              <div key={f.label} className="flex justify-between">
                <span className="text-muted-foreground">{f.label}</span>
                <span>{f.value}</span>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
